import type { MouseEvent } from "react";
import clsx from "clsx";
import { PublishStatus } from "common/constants";
import { FolderBranchLine } from "../../FolderBranchLine";
import { SidebarItemRowContent } from "./SidebarItemRowContent";
import type { SidebarItemRowProps } from "./types";

export const SidebarItemRow = ({
  item,
  position,
  folderBranch,
  isSelected,
  isPending,
  actionItems,
  href,
  onClick,
  onLinkOpenedInNewTab,
  listItemRef,
  normalizedSearchQuery,
}: SidebarItemRowProps) => {
  const isUnpublished = item.publishStatus === PublishStatus.UNPUBLISHED;

  const rowClassName = clsx(
    "group block w-full select-none rounded-l-md border-r-2 px-2 py-1.5 text-left text-sm font-medium transition-colors",
    isSelected
      ? isUnpublished
        ? "bg-amber-100 text-amber-900 border-amber-500"
        : "bg-blue-50 text-blue-700 border-blue-600"
      : isUnpublished
        ? "bg-amber-50 text-amber-800 hover:bg-amber-100 border-transparent"
        : "text-gray-700 hover:bg-gray-50 border-transparent",
  );

  const handleLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
    // Cmd/Ctrl/Shift-clicks fall through, so the browser opens the plan in a new tab or window.
    if (event.metaKey || event.ctrlKey || event.shiftKey) {
      onLinkOpenedInNewTab(item);
      return;
    }
    event.preventDefault();
    onClick(item);
  };

  const handleLinkAuxClick = (event: MouseEvent<HTMLAnchorElement>) => {
    // Middle click: the browser opens the link in a new tab.
    if (event.button === 1) onLinkOpenedInNewTab(item);
  };

  return (
    <li
      ref={listItemRef}
      className={folderBranch === "none" ? "pl-2" : "relative ml-6 pl-4"}
    >
      {folderBranch !== "none" && <FolderBranchLine branch={folderBranch} />}
      {href === null ? (
        <button
          type="button"
          onClick={() => onClick(item)}
          className={rowClassName}
        >
          <SidebarItemRowContent
            item={item}
            position={position}
            isSelected={isSelected}
            isPending={isPending}
            isUnpublished={isUnpublished}
            actionItems={actionItems}
            normalizedSearchQuery={normalizedSearchQuery}
          />
        </button>
      ) : (
        <a
          href={href}
          draggable={false}
          onClick={handleLinkClick}
          onAuxClick={handleLinkAuxClick}
          className={rowClassName}
        >
          <SidebarItemRowContent
            item={item}
            position={position}
            isSelected={isSelected}
            isPending={isPending}
            isUnpublished={isUnpublished}
            actionItems={actionItems}
            normalizedSearchQuery={normalizedSearchQuery}
          />
        </a>
      )}
    </li>
  );
};
